import { render, staticRenderFns } from "./UserAvatar.html?vue&type=template&id=2db48f58&scoped=true&external"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserAvatar.scss?vue&type=style&index=0&id=2db48f58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db48f58",
  null
  
)

export default component.exports